export enum RegistrationClientStatusEnum {
    ALL = 'Todos',
    ENABLED = 'Ativos',
    DISABLED = 'Inativos',
    BLOCKED = 'Bloqueados',
    UNBLOCKED = 'Desbloqueados',
}

export type RegistrationClientStatus = 'ENABLED' | 'DISABLED' | 'BLOCKED' | 'UNBLOCKED' | 'ALL';
